export default __webpack_public_path__ + "static/media/hotel-resort-img-17.de772abf.jpg";